var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingpageArrowLower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "831px",
    height: "119px",
    viewBox: "0 0 831 119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0%",
    cy: "100%",
    fx: "0%",
    fy: "100%",
    r: "1372.86841%",
    gradientTransform: "translate(0.000000,1.000000),scale(1.000000,0.109816),rotate(-90.000000),scale(1.000000,1.134860),translate(-0.000000,-1.000000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B7EC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-398.000000, -689.000000)",
    fillRule: "nonzero",
    stroke: "url(#radialGradient-1)",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANIMATE_intro?draw&delay=2.1",
    transform: "translate(806.000000, 746.500000) rotate(270.000000) translate(-806.000000, -746.500000) translate(749.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/line-corner-copy-2",
    transform: "translate(57.000000, 415.250000) scale(1, -1) translate(-57.000000, -415.250000) translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,830.5 L0,48 C-2.19814969e-15,30.0507456 14.5507456,15.5 32.5,15.5 L89.5,15.5 L89.5,15.5",
    id: "line"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingpageArrowLower);
export default __webpack_public_path__ + "static/media/landingpage-arrow-lower.161af8f9f330a40e3a397954fe024db6.svg";
export { ForwardRef as ReactComponent };